import { i18n } from "@lingui/core";
import { ClasswizEmulatorLicense } from "../../types/AdditionalLicenseType";
import { AdditionalLicense } from "../../types/License";
import { LicenseEntryViewClasswizCalcApp } from "./LicenseEntryViewClasswizCalcApp";
import styles from "./LicenseEntry.module.scss";
import { LicenseEntryAddonClasswizCalcApp } from "./LicenseEntryAddonClasswizCalcApp";

export interface LicenseEntryClasswizCalcAppProps {
  license?: AdditionalLicense;
  isClasswizCalcAppValid?: boolean;
}

export const LicenseEntryClasswizCalcApp = ({
  license,
  isClasswizCalcAppValid,
}: LicenseEntryClasswizCalcAppProps) => {
  return (
    <LicenseEntryViewClasswizCalcApp
      productName={i18n._({
        id: "products.name.classwiz_calc_app",
      })}
      license={license}
      color={"aliceblue"}
      isClasswizCalcAppValid={isClasswizCalcAppValid}
    >
      {
        <>
          <p className={styles.licenseEntryView__info__blue}>
            {i18n._({
              id: "products.info.classwiz_calc_app",
            })}
          </p>

          <LicenseEntryAddonClasswizCalcApp
            activeLicense={license?.license as ClasswizEmulatorLicense}
            validUntil={license?.validUntil}
            color={"aliceblue"}
          />
        </>
      }
    </LicenseEntryViewClasswizCalcApp>
  );
};
